<ngb-pagination
  *ngIf="collectionSize > pageSize"
  class="pagination-component"
  [collectionSize]="collectionSize"
  [maxSize]="maxSize"
  [page]="page"
  [pageSize]="pageSize"
  (pageChange)="pageChange.emit($event)">
</ngb-pagination>
